"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftWidget = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_jss_1 = __importDefault(require("react-jss"));
const surface_1 = require("../../../../../../surface");
const draftReaderWidget_1 = __importDefault(require("../../../reader/widgets/draftReaderWidget"));
const withInlineValidation_1 = __importDefault(require("../../../../../wrappers/withInlineValidation"));
const links_1 = require("../../../../../utils/links");
const draft_style_1 = __importDefault(require("./draft.style"));
const DraftWidget = ({ classes, id, value, onChange, formContext, placeholder }) => {
    // check if the widget is locked because of forms links
    const isLocked = links_1.isLockedWidget(id, formContext.links);
    // if it is locked redirect to draft reader widget
    if (isLocked)
        return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.readerWrapper }, { children: jsx_runtime_1.jsx(draftReaderWidget_1.default, { value: value, schema: {} }, void 0) }), void 0));
    return (jsx_runtime_1.jsx(surface_1.RichEditor, { placeholder: placeholder || 'My new comment goes here.', onChange: onChange, initialValue: value }, void 0));
};
exports.DraftWidget = DraftWidget;
exports.default = withInlineValidation_1.default(react_jss_1.default(draft_style_1.default)(exports.DraftWidget));
//# sourceMappingURL=index.js.map